import React, { Component } from 'react';
import { localize } from 'react-localize-redux';
import { serviceRequestOptions } from 'helpers/VerbiageHelper';

export default localize()(
  class ProgressInEnglish extends Component {
    render() {
      const statusMap = {
        new: serviceRequestOptions({
          serviceRequest: this.props.translate('tenantVerbiage.new'),
          requestForMaintenance: this.props.translate('tenantVerbiage.newRFM'),
        }),
        Reviewed: serviceRequestOptions({
          serviceRequest: this.props.translate('tenantVerbiage.reviewed'),
          requestForMaintenance: this.props.translate('tenantVerbiage.reviewedRFM'),
        }),
        assigned: serviceRequestOptions({
          serviceRequest: this.props.translate('tenantVerbiage.assigned'),
          requestForMaintenance: this.props.translate('tenantVerbiage.assignedRFM'),
        }),
        Scheduled: this.props.translate('tenantVerbiage.scheduled'),
        Deferred: this.props.translate('tenantVerbiage.additionalWorkRequired'),
        auto_deferred: this.props.translate('tenantVerbiage.additionalWorkRequired'),
        Fixing: this.props.translate('tenantVerbiage.fixing'),
        Fixed: serviceRequestOptions({
          serviceRequest: this.props.translate('tenantVerbiage.fixed'),
          requestForMaintenance: this.props.translate('tenantVerbiage.fixedRFM'),
        }),
        'Parts Needed': this.props.translate('tenantVerbiage.additionalWorkRequired'),
        Closed: this.props.translate('tenantVerbiage.closed'),
        'Contractor Needed': this.props.translate('tenantVerbiage.additionalWorkRequired'),
        'Contact Tenant': this.props.translate('tenantVerbiage.unhappyTenant'),
      };

      return (
        <span>
          {statusMap[this.props.status] ||
            serviceRequestOptions({
              serviceRequest: this.props.translate('tenantVerbiage.reviewed'),
              requestForMaintenance: this.props.translate('tenantVerbiage.reviewedRFM'),
            })}
        </span>
      );
    }
  }
);
